var styles = {
  "Container": "pb-Select__Container",
  "Container--fullWidth": "pb-Select__Container--fullWidth",
  "Value": "pb-Select__Value",
  "Placeholder": "pb-Select__Placeholder",
  "Value--invalid": "pb-Select__Value--invalid",
  "Select": "pb-Select__Select",
  "Select--invalid": "pb-Select__Select--invalid",
  "Icon": "pb-Select__Icon"
};
export default styles;